// removed by extract-text-webpack-plugin
module.exports = {"sidebarInfo":"O2voITk0jDaJ8a0BRdl5A","name":"cGp_NNeWODGemPDOnOq4V","infoList":"_2AYsbpkk_DesnoUUXLsZyC"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/PharmacySidebarInfo.scss
// module id = 564
// module chunks = 0